module.exports = __webpack_public_path__ + "h5/img/backStaff.bfcbe276.jpg";